import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import { useEffect } from "react";
import { useFieldArray, useForm } from "react-hook-form";

const QuestionForm = ({ title, label }) => {
  const { register, control } = useForm();

  const { fields, append, remove } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: "Question Form", // unique name for your Field Array
  });

  useEffect(() => {
    append();
  }, []);

  return (
    <div>
      <Paper sx={{ padding: "1rem" }}>
        <Typography variant="h4">{title}</Typography>
        <ul style={{ listStyleType: "none" }}>
          {/* <Paper sx={{ padding: "1rem" }}> */}
          {fields.map((field, index) => (
            <li>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Question</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput fullWidth />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Marked Option</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput fullWidth />
                </Grid>
                <Grid item xs={12}>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox defaultChecked />}
                      label="Is Correct"
                      // sx={{ marginTop: "1rem" }}
                    />
                  </FormGroup>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Marks</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput fullWidth />
                </Grid>
              </Grid>
              {/* <MDBox m={1} p={2}> */}

              <MDBox sx={{ textAlign: "right" }}>
                <MDButton
                  variant="contained"
                  onClick={(e) => {
                    e.preventDefault();
                    remove(index);
                  }}
                >
                  <Typography color="error" variant="body">
                    Remove
                  </Typography>
                </MDButton>
              </MDBox>
              {/* </MDBox> */}
            </li>
          ))}
          <MDButton
            variant="contained"
            color="info"
            onClick={(e) => {
              e.preventDefault();
              append({ title: `${title}` });
            }}
          >
            + Add
          </MDButton>
        </ul>
      </Paper>
    </div>
  );
};

export default QuestionForm;
